import script from "./AggregationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AggregationPage.vue?vue&type=script&setup=true&lang=js"

import "./AggregationPage.vue?vue&type=style&index=0&id=2ea8803e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea8803e"]])

export default __exports__